var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "todo" }, [
    _c("div", { staticClass: "view" }, [
      _c("input", { staticClass: "toggle", attrs: { type: "checkbox" } }),
      _vm._v(" "),
      _c("div", { staticClass: "inner" }, [
        _c("div", { staticClass: "label" }, [
          _vm._v("\n        " + _vm._s(_vm.todo.label) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [
          _vm._v(
            "\n        : " +
              _vm._s(_vm.formatNumber(_vm.todo.value)) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("input", { staticClass: "edit", domProps: { value: _vm.todo } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }